import { Routes } from '@angular/router';

import { ChatShellComponent } from './pages/chat-shell/chat-shell.component';
import { DebugComponent } from './pages/debug/debug.component';
import { authRequiredGuard } from './guards/auth-required.guard';
import { RegisterComponent } from './pages/auth/register/register.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'chat' },
  { path: 'register', component: RegisterComponent },
  { path: 'chat', component: ChatShellComponent, canActivate: [authRequiredGuard] },
  { path: 'debug/:debugId', component: DebugComponent, canActivate: [authRequiredGuard] },
  { path: '**', redirectTo: 'chat' },
];
